import {
    createDBInputValidation,
    createDBEntityValidator,
} from 'shared/db/validation/common';
import { Logger } from 'shared/db/validation/databaseInput';
import { createHorseContactsSchemas } from 'shared/db/validation/schema/horseContacts';
import { Validator } from 'shared/db/validation/validator';
import {
    HorseContactRawRecord,
    HorseContactUpdateRawRecord,
} from 'shared/types/HorseContact';
import { DeleteRawRecord } from 'shared/types/rawRecordFields';
import { HorseContactDBValidation } from 'shared/types/validation';

import { createLoggerFor } from '@/services/logger';
import { getValidationStrategy } from '@/utils/validations';

const schemas = createHorseContactsSchemas();

const addValidator = createDBEntityValidator<HorseContactRawRecord>(
    schemas.add,
);
const updateValidator = createDBEntityValidator<HorseContactUpdateRawRecord>(
    schemas.update,
);
const deleteValidator = createDBEntityValidator<DeleteRawRecord>(
    schemas.delete,
);

const softValidation = {
    logger: createLoggerFor('db-validation-horse-contacts'),
    hardErrorFields: [],
};

const validationStrategy = getValidationStrategy(softValidation);

export const createHorseContactsInputValidation = <
    T extends Record<string, unknown>,
>(
    validator: Validator<T>,
    softValidation?: {
        logger: Logger;
        hardErrorFields: string[];
    },
) => createDBInputValidation<T>(validator, softValidation);

export const horseContactsInputValidation: HorseContactDBValidation = {
    add: createHorseContactsInputValidation(addValidator, validationStrategy),
    update: createHorseContactsInputValidation(
        updateValidator,
        validationStrategy,
    ),
    delete: createHorseContactsInputValidation(
        deleteValidator,
        validationStrategy,
    ),
};
